import React, { useState, useEffect } from "react";
import { CheckCircleOutline, ErrorOutline, Sync } from "@material-ui/icons";
import { useSelector } from "react-redux";
import moment from "moment";

import "../../../css/eposnow.css";
import useAPI from "../../../yoello-lib/modules/API/useAPI";
import APIDefintions from "../../../yoello-lib/modules/API/APIDefs";
// import { useAuth0 } from "../../../yoello-lib/modules/auth/Auth0";
import { useTranslation } from "react-i18next";
import { AlertStatusCard } from "../../../yoello-lib/modules/components/UI/Alerts/AlertStatusCard";
import SyncCard from "../../../container/SquareSyncView/SyncCard";
import { IReduxAppState } from "../../../reducers";
import { ReactComponent as Time } from "../../../assets/images/icon-time-circle.svg";
import { useAPIV2 } from "../../../yoello-lib/modules/API2/useAPIv2";
import APIExtensions from "../../../yoello-lib/modules/API2/APIDefs";
import { HTTPMethods } from "../../../yoello-lib/modules/API/API";

import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import useCheckPermissions from "../../../hooks/useCheckPermissions";
import { PERMISSIONS } from "../../../const/permissions.const";
import DisabledActionWrapper from "../../../yoello-lib/modules/components/DisabledActionWrapper";
import { useAuthenticationContext } from "../../../yoello-lib/modules/auth/AuthenticationContext";
// import { TillSettings } from "./TillSettings";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paragraph: {
      fontSize: "1rem",
      lineHeight: "1.5",
      color: "#333333",
    },
    time: {
      marginRight: "0.5rem",
    },
    buttonAside: {
      marginLeft: "1rem",
      fontSize: "1rem",
    },
  })
);

export function EposNowPage() {
  const classes = useStyles();
  const { retrieveAccessToken } = useAuthenticationContext();
  const { t } = useTranslation();

  const [syncData, setSyncData] = useState<any>();
  const [refreshSyncTime, setRefreshSyncTime] = useState<any>(false);

  const { 
    hasPermission: hasMenuManagement, 
    onFailedInteraction: onFailedMenuInteraction
} = useCheckPermissions(PERMISSIONS.MENU_MANAGEMENT);

  const seletectedVenueId = useSelector(
    (state: IReduxAppState) => state.selectedVenueId
  );

  const { callAPI: callMenusAPI } = useAPI(
    APIDefintions.syncMenu,
    retrieveAccessToken,
    {
      query:`v2/venues/${seletectedVenueId}/sync_menu`,
      onMountDisabled: true,
    }
  );

  const { callAPI: callSyncStatus } = useAPIV2(
    APIExtensions.eposnowSyncStatus,
    {
      onMountDisabled: true,
    }
  );

  useEffect(() => {
    callSyncStatus(HTTPMethods.POST, {
      query: "?sort_field=updated_on&sort_direction=desc",
      body: {
        filters: [
          {
            field_name: "venue_id",
            operator: "=",
            value: seletectedVenueId,
          },
          {
            field_name: "status",
            operator: "=",
            value: "SUCCESSFUL",
          },
        ],
      },
    }).then((data) => {
      const dataAsArray = data.data as any[];

      setSyncData(dataAsArray[0]);
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshSyncTime]);

  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const buttonAside = (
    <div className={classes.buttonAside}>
      <div>
        <Time className={classes.time} />

        {t("eposNow.sync.menus.buttonAside")}
      </div>

      <div>
        {moment(syncData?.updated_on)
          .utc()
          .tz(timezone)
          .format("DD/MM/YYYY hh:mm A")}
      </div>
    </div>
  );

  const menusMessages = {
    success: {
      icon: <CheckCircleOutline />,
      title: t("eposNow.sync.menus.success.title"),
      description: t("eposNow.sync.menus.success.description"),
    },
    error: {
      icon: <ErrorOutline />,
      title: t("eposNow.sync.menus.fail.title"),
      description: t("eposNow.sync.menus.fail.description"),
    },
    active: {
      icon: <Sync />,
      title: t("eposNow.sync.menus.active.title"),
      description: t("eposNow.sync.menus.active.description"),
    },
    hidden: {
      icon: null,
      title: "",
      description: "",
    },
  };

  return (
    <div>
      <DisabledActionWrapper
        disabled={!hasMenuManagement}
        onDisabledClick={onFailedMenuInteraction}
      >
        <SyncCard
          callAPI={callMenusAPI}
          disabled={!hasMenuManagement}
          title={""}
          description={
            <>
              <p className={classes.paragraph}>{t("eposNow.eposIntro")}</p>
              <p className={classes.paragraph}>{t("eposNow.step1")}</p>
              <p className={classes.paragraph}>{t("eposNow.step2")}</p>
              <p className={classes.paragraph}>{t("eposNow.step3")}</p>
            </>
          }
          descriptionAfter={
            <>
              <p className={classes.paragraph}>{t("eposNow.helperText")}</p>
            </>
          }
          buttonText={t("eposNow.sync.menus.button")}
          buttonAside={syncData?.updated_on && buttonAside}
          messages={menusMessages}
          query={(vanue) => vanue}
          getStatusId={(syncStatus) => syncStatus?.sync_status_id}
          onSyncCompleted={() => setRefreshSyncTime(!refreshSyncTime)}
          syncOnlyOneVenue={seletectedVenueId}
          hasAddItemsToMenuSection={true}
          isEposNow={true}
        />

      </DisabledActionWrapper>
      
      
      {/* <div>
        <TillSettings />
      </div> */}

      <div className="eposAlert">
        <AlertStatusCard
          alertProps={{ severity: "info" }}
          alertTitle={<b>{t("eposNow.supportTitle")}</b>}
          alertMessage={
            <>
              {t("eposNow.supportText")}{" "}
              <b>
                <a href={"mailto: eposnow@yoello.com"}>eposnow@yoello.com</a>
              </b>
            </>
          }
        />
      </div>
    </div>
  );
}
